export class FrameworkSettings {
    PAYMENT_GATEWAY:String;
}